import * as React from "react";
import BooksComponent from "../components/Books/BooksComponent";

export default function Books() {
  return (
    <main className="min-h-screen pt-24">
      <div className="page-container">
        <h1 className="text-4xl sm:text-5xl font-semibold text-foreground tracking-tight mb-4">
          Books
        </h1>
        <p className="text-muted text-lg mb-12 max-w-2xl">
          Books that have shaped my thinking - with key quotes and takeaways.
        </p>
        <BooksComponent />
      </div>
    </main>
  );
}
